"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgGuideFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.guide_filled_svg__cls-1{display:none}')),
        React.createElement("g", { id: "guide_filled_svg__transparent_box" },
            React.createElement("path", { className: "guide_filled_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "guide_filled_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("path", { d: "M9.5 25H26V2H9.5A3.5 3.5 0 006 5.5V26a2.74 2.74 0 000 .5A3.5 3.5 0 009.5 30H26v-2H9.5a1.5 1.5 0 010-3zm7.5-6h-2v-7h2zM16 7a1.5 1.5 0 110 3 1.5 1.5 0 110-3z", id: "guide_filled_svg__FILLED" })));
}
exports.default = SvgGuideFilled;
//# sourceMappingURL=GuideFilled.js.map